<script setup lang="ts">
import ModalDialogContent from '@/components/ModalDialogContent.vue'
import TextInput from '@/components/TextInput.vue'
import {useI18n} from 'vue-i18n'

const {t} = useI18n()

defineProps<{
  id: string
  error?: string
}>()

const editTitle = defineModel<string>({required: true})
</script>

<template>
  <ModalDialogContent :id="id">
    <div class="flex flex-col gap-4">
      <TextInput v-model="editTitle" :placeholder="t('assistant.conversation.editPlaceholder')" />
      <span class="text-red text-sm">{{ error }}</span>
    </div>
  </ModalDialogContent>
</template>
